import React, { useMemo, useState, useEffect, useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button } from "../../primary";
import styles from "./assign.module.scss";
import topArrow from "../../../static/images/toparrow.svg";
import downArrow from "../../../static/images/downarrow.svg";
import deleteIcon from "../../../static/images/delete-icon.png";
import plusIconWhite from "../../../static/images/plus-icon_white.svg";
import {
  setUpdateStatus,
  productCategoryListOptions,
  getMateriallist,
  updateFormBuilderMediaList,
  upDateformDetailsAsync,
} from "../../../app/customFormSlice";
import { AddRule } from "./addRule";
import { AddRuleText } from "./addRuleText";
import { CloseWarning } from "../../secondary";
import { Confirmation } from "../../secondary/Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import ImageIcon from "../../../static/images/products/image_icon.svg";
import CloseIcon from "../../../static/images/products/close_icon.svg";
import Loader from "../../../static/images/spinner.svg";
import { toggleMandatory } from "./formBuilderUtils";
import { useHistory } from "react-router-dom";
import { Toggle } from "./toggle";
import FormHeader from "./formHeader";
import SectionBlock from "./sectionBlock";
import FormFooter from "./formFooter";
import { QuestionBody } from "./questionBody";
import Tooltip from "../../secondary/Tooltip/tooltip";
import constants from "../../../constants/constants.json";
import UnSectionBlock from "./unSectionBlock";

export const FormBuilder = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  const formData = useSelector((state) => state.forms.formDetailsData);
  const upDateStatus = useSelector((state) => state.forms.upDateStatus);
  const isFormLoading = useSelector((state) => state.forms.isFormLoading);

  const [sectionInfo, setSectionInfo] = useState([]);
  const [customFormBuilder, setcustomFormBuilder] = useState([]);
  const [getRule, setRule] = useState(false);
  const [ruleList, setRuleList] = useState([]);
  const [ruleEmpty, setRuleEmpty] = useState("");
  const [branch, setBranch] = useState(false);
  const [addBranchIndex, setBranchIndex] = useState("");
  const [modalShowRule, setmodalShowRule] = useState(false);
  const [getIndex, setIndex] = useState({});
  const [editRule, setEditRule] = useState();
  const [showQuestionError, setQuestionError] = useState();
  const [deleteInd, setDeleteInd] = useState("");
  const [deleteIndRule, setDeleteIndRule] = useState(false);
  const [getRuleIndex, setGetRuleIndex] = useState([]);
  const [modalShow, setmodalShow] = useState(false);
  const [closeWarning, setCloseWarning] = useState(false);
  const [addMedia, setAddMedia] = useState();
  const [deleteQuestionCon, setDeleteQuestionCon] = useState(false);

  const [dragOverTarget, setDragOverTarget] = useState({
    sectionIndex: null,
    questionIndex: null,
  });

  const sectionRefs = useRef([]);
  const unSectionRefs = useRef([]);
  const dropRef = useRef(null);
  const dragItemRef = useRef(null);
  const hasProductMaterialRef = useRef(false);

  const SCROLL_EDGE_OFFSET = 80;
  const SCROLL_SPEED = 20;

  const handleAutoScroll = (e) => {
    const { clientY } = e;
    const viewportHeight = window.innerHeight;

    if (clientY < SCROLL_EDGE_OFFSET) {
      window.scrollBy({ top: -SCROLL_SPEED, behavior: "auto" });
    } else if (clientY > viewportHeight - SCROLL_EDGE_OFFSET) {
      window.scrollBy({ top: SCROLL_SPEED, behavior: "auto" });
    }
  };

  const getQuestionIndex = useCallback(
    (tempId) => {
      return customFormBuilder.findIndex((q) => q.tempId === tempId);
    },
    [customFormBuilder]
  );

  const handleToggle = (index) => {
    setcustomFormBuilder((prev) => toggleMandatory(prev, index));
  };

  const handleSectionToggle = (index) => {
    const updatedSections = toggleMandatory(sectionInfo, index);

    const isSectionMandatory = updatedSections[index].isMandatory === 1;

    const updatedQuestions = customFormBuilder.map((q) =>
      updatedSections[index].questionsId.includes(q.tempId)
        ? {
            ...q,
            isMandatory: isSectionMandatory ? 0 : q.isMandatory,
          }
        : q
    );
    setSectionInfo(updatedSections);
    setcustomFormBuilder(updatedQuestions);
  };

  const sectionedQuestionIds = useMemo(() => {
    return new Set(sectionInfo.flatMap((sec) => sec.questionsId));
  }, [sectionInfo]);

  const unSectionedQuestions = useMemo(() => {
    return customFormBuilder.filter((q) => !sectionedQuestionIds.has(q.tempId));
  }, [customFormBuilder, sectionedQuestionIds]);

  const prevSectionLength = useRef(sectionInfo.length);
  const prevUnSectionLength = useRef(unSectionedQuestions.length);

  useEffect(() => {
    if (sectionInfo.length > prevSectionLength.current) {
      const newSectionIndex = sectionInfo.length - 1;

      sectionRefs.current[newSectionIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    prevSectionLength.current = sectionInfo.length;
  }, [sectionInfo.length]);

  useEffect(() => {
    if (unSectionedQuestions.length > prevUnSectionLength.current) {
      const newUnsectionIndex = unSectionedQuestions.length - 1;

      unSectionRefs.current[newUnsectionIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    prevUnSectionLength.current = unSectionedQuestions.length;
  }, [unSectionedQuestions.length]);

  useEffect(() => {
    reset({});

    const timeoutId = setTimeout(() => {
      dispatch(setUpdateStatus({}));
    }, 1000);

    if (!hasProductMaterialRef.current && formData?.formBuilderInfo?.length > 0) {
      hasProductMaterialRef.current = true;
      dispatch(productCategoryListOptions());
      dispatch(getMateriallist());
    }

    const builder =
      formData?.formBuilderInfo?.length > 0
        ? [...formData.formBuilderInfo]
            .sort((a, b) => a.order - b.order)
            .map((q) => ({
              ...q,
              tempId: q.id > 0 ? q.id : crypto.randomUUID(),
            }))
        : [];

    setcustomFormBuilder(builder);

    const sections =
      formData?.sectionInfo?.length > 0
        ? formData.sectionInfo.map((sec) => ({
            name: sec.name,
            sectionPlaceholder: sec.sectionPlaceholder,
            sectionId: sec.sectionId,
            isMandatory: sec.isMandatory,
            questionsId: sec.questionsId ?? [],
          }))
        : [];

    setSectionInfo(sections);

    return () => clearTimeout(timeoutId);
  }, [formData, reset, dispatch]);

  const addRuleButton = useCallback(() => {
    handleAddMediaCancel();
    setRule(false);

    dispatch(upDateformDetailsAsync({ ...formData, formBuilderInfo: customFormBuilder }));
  }, [dispatch, formData, customFormBuilder]);

  const handleDeleteImage = (imagesList, formId, questionId, questionIndex, indexImg) => {
    const filtered = Array.isArray(imagesList) && imagesList.filter((data, i) => i !== indexImg);
    let list = { images: [] };
    if (filtered && filtered.length > 0) {
      list["images"] = [...filtered];
    }
    dispatch(updateFormBuilderMediaList({ formId, questionId, list, questionIndex, customFormBuilder, setcustomFormBuilder, setSectionInfo }));
    handleAddMediaCancel();
  };

  const onSubmit = () => {
    handleAddMediaCancel();

    const feature = formData?.assignInfo?.feature;
    const isNE1WMS = feature === "NE1 WMS";

    let hasError = false;
    let saveRuleOption = false;

    const scrollToError = (index, focusInput = false) => {
      setQuestionError({ index });
      const errEl = document.querySelector(`.err_val${index}`);
      errEl?.scrollIntoView({ behavior: "smooth" });
      if (focusInput) {
        errEl?.querySelector("input[type='text']")?.focus();
      }
    };

    for (let index = 0; index < customFormBuilder.length; index++) {
      const item = customFormBuilder[index];
      if (!item?.desc) {
        hasError = true;
        scrollToError(index, true);
        break;
      }
      if (item.goto === "eof" && !isNE1WMS) {
        if (item.rule === null) {
          setRuleEmpty("One / more End of form question rule not configured");
          hasError = true;
          scrollToError(index);
          break;
        }
        if (item.rule === undefined) {
          saveRuleOption = true;
        }
      }

      for (const opt of item?.options || []) {
        if (!opt.value) {
          hasError = true;
          scrollToError(index);
          break;
        }

        if (opt.goto === "eof" && !isNE1WMS) {
          if (opt.rule === null && item.id !== 0) {
            setRuleEmpty("One / more End of form question rule not configured");
            hasError = true;
            scrollToError(index);
            break;
          }
          if (opt.rule === undefined) {
            saveRuleOption = true;
          }
        }
      }

      if (hasError) break;
    }

    if (document.querySelector(".err-msg-product")?.offsetTop !== undefined) {
      hasError = true;
    }

    if (getRuleIndex.length > 0) {
      hasError = true;
    }

    if (hasError) return;

    setQuestionError({});

    if (saveRuleOption && !isNE1WMS) {
      setRule(true);
      setmodalShow(true);
      setUpdateStatus({});
      return;
    }

    setRuleEmpty("");

    const tempIdToQuestionMap = new Map(customFormBuilder.map((q) => [q.tempId, q]));

    const tempIdToSectionMap = new Map();
    sectionInfo.forEach((sec) => {
      sec.questionsId?.forEach((tempId) => {
        tempIdToSectionMap.set(tempId, sec);
      });
    });

    const result = {
      ...formData,
      formBuilderInfo: customFormBuilder.map((q) => {
        const section = q.tempId ? tempIdToSectionMap.get(q.tempId) : null;

        return {
          ...q,
          tempId: undefined,
          sectionName: section?.name ?? null,
          sectionId: section?.sectionId ?? null,
        };
      }),

      sectionInfo: sectionInfo.map((sec) => ({
        ...sec,
        sectionId: sec?.sectionId ?? null,
        sectionPlaceholder: sec?.sectionPlaceholder ?? null,
        questionsId: sec.questionsId.map((tempId) => tempIdToQuestionMap.get(tempId)?.id ?? 0),
      })),
    };

    dispatch(upDateformDetailsAsync(result));
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickOutside = (e) => {
    if (dropRef !== null && dropRef.current && !dropRef.current.contains(e.target)) {
      setBranch(false);
    }
  };

  const addBranch = (index) => {
    handleAddMediaCancel();
    setBranch(true);
    setBranchIndex(index);
  };

  // select question type
  const selectAnswerType = (value, index) => {
    handleAddMediaCancel();
    if (!value) return;

    const makeDefaultOptions = () => [
      { key: "1", value: "", order: 1, goto: "" },
      { key: "2", value: "", order: 2, goto: "" },
    ];

    setcustomFormBuilder((prev) => {
      if (index < 0 || index >= prev.length) return prev;

      const updated = [...prev];
      const isText = value === "text";

      updated[index] = {
        ...updated[index],
        type: value,
        goto: "",
        options: isText ? [] : makeDefaultOptions(),
      };

      return updated;
    });
  };

  // add branch
  const addBranchValue = (branchValue, pIndex) => {
    setcustomFormBuilder((prev) => {
      const next = [...prev];
      const question = { ...next[pIndex] };

      const isAddForOptions = branchValue === "Add for options";

      question.goto = isAddForOptions ? "" : "next";
      delete question.rule;

      question.options = (question.options || []).map((opt) => {
        const updatedOpt = { ...opt };
        updatedOpt.goto = isAddForOptions ? "next" : "";
        delete updatedOpt.rule;
        return updatedOpt;
      });

      next[pIndex] = question;
      return next;
    });

    setBranch(false);
  };

  // add new answer based on type
  const addNewQuestionOption = (value, type, parentIndex) => {
    handleAddMediaCancel();
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = [...customFormObject[parentIndex].options];

    let addNewQuestionOptionVal = {
      "1": `Option${selectTypeDat.length + 1}`,
      "2": "Others",
      "3": "All of the above",
      "4": "None of the above",
    };
    let addNewQuestionOptionKey = {
      "1": `Option${selectTypeDat.length + 1}`,
      "2": "other",
      "3": "alloftheabove",
      "4": "noneoftheabove",
    };

    if (
      customFormObject[parentIndex] &&
      customFormObject[parentIndex]?.optionType &&
      customFormObject[parentIndex]?.optionType === "productattribute"
    ) {
      selectTypeDat = [
        ...selectTypeDat,
        {
          order: (selectTypeDat.length + 1) * 1,
          key: `${value.key !== "1" ? addNewQuestionOptionKey[value.key] : selectTypeDat.length + 1}`,
          value: value.key !== "1" ? addNewQuestionOptionVal[value.key] : "",
          goto:
            selectTypeDat[0] && selectTypeDat[0].goto !== null && selectTypeDat[0].goto !== undefined && selectTypeDat[0].goto !== "" ? "next" : "",
          attributeValueKey: 0,
        },
      ];
    } else {
      selectTypeDat = [
        ...selectTypeDat,
        {
          order: (selectTypeDat.length + 1) * 1,
          key: `${value.key !== "1" ? addNewQuestionOptionKey[value.key] : selectTypeDat.length + 1}`,
          value: value.key !== "1" ? addNewQuestionOptionVal[value.key] : "",
          goto:
            selectTypeDat[0] && selectTypeDat[0].goto !== null && selectTypeDat[0].goto !== undefined && selectTypeDat[0].goto !== "" ? "next" : "",
        },
      ];
    }
    let addAnswer = { ...customFormObject[parentIndex] };
    addAnswer.options = selectTypeDat;
    let other = addAnswer?.options?.find((o) => o.value === "Others");
    let alloftheabove = addAnswer?.options?.find((o) => o.value === "All of the above");
    let noneoftheabove = addAnswer?.options?.find((o) => o.value === "None of the above");
    addAnswer.addOption = [
      { key: "1", value: "Add answer", visible: 1 },
      { key: "2", value: "Add other", visible: other ? 0 : 1 },
      { key: "3", value: "Add all of the above", visible: alloftheabove ? 0 : 1 },
      { key: "4", value: "Add none of the above", visible: noneoftheabove ? 0 : 1 },
    ];
    let customFormObj = [...customFormObject];
    customFormObj.splice(parentIndex, 1, addAnswer);
    setcustomFormBuilder(customFormObj);
  };

  // deleteAnswerOption
  const deleteAnswerOption = (index, pIndex) => {
    handleAddMediaCancel();
    reset({});

    setcustomFormBuilder((prev) => {
      const next = [...prev];
      const question = { ...next[pIndex] };

      const options = (question.options || []).length > 2 ? question.options.filter((_, i) => i !== index) : [...(question.options || [])];

      const hasOther = options.some((o) => o.value === "Others");
      const hasAll = options.some((o) => o.value === "All of the above");
      const hasNone = options.some((o) => o.value === "None of the above");

      question.options = options;
      question.addOption = [
        { key: "1", value: "Add answer", visible: 1 },
        { key: "2", value: "Add other", visible: hasOther ? 0 : 1 },
        { key: "3", value: "Add all of the above", visible: hasAll ? 0 : 1 },
        { key: "4", value: "Add none of the above", visible: hasNone ? 0 : 1 },
      ];

      next[pIndex] = question;
      return next;
    });
  };

  // up arrow sequence
  const upArrowSequence = (tempId, sectionIndex = null) => {
    handleAddMediaCancel();
    reset({});
    setcustomFormBuilder((prev) => {
      const updated = [...prev];
      if (sectionIndex !== null) {
        const section = sectionInfo[sectionIndex];
        const ids = [...section.questionsId];

        const pos = ids.indexOf(tempId);
        if (pos <= 0) return prev;

        [ids[pos - 1], ids[pos]] = [ids[pos], ids[pos - 1]];

        setSectionInfo((prevSecs) => prevSecs.map((sec, idx) => (idx === sectionIndex ? { ...sec, questionsId: ids } : sec)));

        return updated.map((q, i) => ({
          ...q,
          order: i + 1,
        }));
      }

      const unsectioned = updated.filter((q) => !sectionedQuestionIds.has(q.tempId));

      const pos = unsectioned.findIndex((q) => q.tempId === tempId);
      if (pos <= 0) return prev;
      const a = unsectioned[pos - 1];
      const b = unsectioned[pos];

      const idxA = updated.findIndex((q) => q.tempId === a.tempId);
      const idxB = updated.findIndex((q) => q.tempId === b.tempId);

      [updated[idxA], updated[idxB]] = [updated[idxB], updated[idxA]];

      return updated.map((q, i) => ({
        ...q,
        order: i + 1,
      }));
    });
  };

  // down arrow sequence
  const downArrowSequence = (tempId, sectionIndex = null) => {
    handleAddMediaCancel();
    reset({});

    setcustomFormBuilder((prev) => {
      const updated = [...prev];

      if (sectionIndex !== null) {
        const section = sectionInfo[sectionIndex];
        const ids = [...section.questionsId];

        const pos = ids.indexOf(tempId);
        if (pos === -1 || pos === ids.length - 1) return prev;

        [ids[pos], ids[pos + 1]] = [ids[pos + 1], ids[pos]];

        setSectionInfo((prevSecs) => prevSecs.map((sec, idx) => (idx === sectionIndex ? { ...sec, questionsId: ids } : sec)));

        return updated.map((q, i) => ({
          ...q,
          order: i + 1,
        }));
      }

      const unsectioned = updated.filter((q) => !sectionedQuestionIds.has(q.tempId));

      const pos = unsectioned.findIndex((q) => q.tempId === tempId);
      if (pos === -1 || pos === unsectioned.length - 1) return prev;

      const a = unsectioned[pos];
      const b = unsectioned[pos + 1];

      const idxA = updated.findIndex((q) => q.tempId === a.tempId);
      const idxB = updated.findIndex((q) => q.tempId === b.tempId);

      [updated[idxA], updated[idxB]] = [updated[idxB], updated[idxA]];

      return updated.map((q, i) => ({
        ...q,
        order: i + 1,
      }));
    });
  };

  const getInputValue = (e, pIndex) => {
    const value = e.target.value;
    setcustomFormBuilder((prev) => prev.map((item, index) => (index === pIndex ? { ...item, placeholder: value } : item)));
  };

  const getAttributeVal = (e, index, attribute) => {
    handleAddMediaCancel();
    e.stopPropagation();
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[index] };

    if (attribute === "productmaterial") {
      if (document.getElementById("productfamily" + index + 1)) {
        document.getElementById("productfamily" + index + 1).checked = false;
      }
      if (document.getElementById("productattribute" + index + 1)) {
        document.getElementById("productattribute" + index + 1).checked = false;
      }
      if (document.getElementById("productfamily" + index + 0)) {
        document.getElementById("productfamily" + index + 0).checked = false;
      }
      if (document.getElementById("productattribute" + index + 0)) {
        document.getElementById("productattribute" + index + 0).checked = false;
      }
    }
    if (attribute === "productattribute") {
      if (document.getElementById("productfamily" + index + 1)) {
        document.getElementById("productfamily" + index + 1).checked = false;
      }
      if (document.getElementById("productmaterial" + index + 1)) {
        document.getElementById("productmaterial" + index + 1).checked = false;
      }
      if (document.getElementById("productfamily" + index + 0)) {
        document.getElementById("productfamily" + index + 0).checked = false;
      }
      if (document.getElementById("productmaterial" + index + 0)) {
        document.getElementById("productmaterial" + index + 0).checked = false;
      }
    }
    if (attribute === "productfamily") {
      if (document.getElementById("productattribute" + index + 1)) {
        document.getElementById("productattribute" + index + 1).checked = false;
      }
      if (document.getElementById("productmaterial" + index + 1)) {
        document.getElementById("productmaterial" + index + 1).checked = false;
      }
      if (document.getElementById("productattribute" + index + 0)) {
        document.getElementById("productattribute" + index + 0).checked = false;
      }
      if (document.getElementById("productmaterial" + index + 0)) {
        document.getElementById("productmaterial" + index + 0).checked = false;
      }
    }

    if (e.target.value === "Yes") {
      selectTypeDat.optionType = attribute;
      delete selectTypeDat.type;
      delete selectTypeDat.productAttributeFilter;

      if (attribute === "productfamily" || attribute === "productmaterial") {
        selectTypeDat.options = [
          {
            key: "1",
            value: "",
            order: 1,
          },
          {
            key: "2",
            value: "",
            order: 2,
          },
        ];
        selectTypeDat.type = "singleselect";
      }
      selectTypeDat.goto = "";
      if (attribute === "productmaterial") {
        dispatch(getMateriallist());
      } else {
        dispatch(productCategoryListOptions());
      }
    } else {
      selectTypeDat.optionType = null;
      selectTypeDat.options = [];
      delete selectTypeDat.type;
      selectTypeDat.goto = "";
      if (document.getElementById("questionType" + index)) {
        document.getElementById("questionType" + index).selectedIndex = "";
      }
    }
    let customFormObj = [...customFormObject];
    customFormObj.splice(index, 1, selectTypeDat);
    setcustomFormBuilder(customFormObj);
  };

  const fetchValue = (index, res, productAttr) => {
    handleAddMediaCancel();
    reset({});

    const options = res?.data?.attributeValue ?? "";

    setcustomFormBuilder((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              type: "singleselect",
              productAttributeFilter: productAttr,
              options,
            }
          : item
      )
    );
  };

  const productAttributeOrderChange = (orderType, index, pIndex) => {
    handleAddMediaCancel();
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[pIndex] };
    let selectTypeDatOptions = [...selectTypeDat.options];
    if (index !== 0 && orderType === "up") {
      reset({});
      selectTypeDatOptions.splice(index - 1, 0, selectTypeDatOptions[index]);
      selectTypeDatOptions.splice(index + 1, 1);
      let orderChange = selectTypeDatOptions.map((value, index) => {
        let order = { ...value };
        order.order = (index + 1) * 1;
        return order;
      });
      selectTypeDat.options = orderChange;
      let customFormObj = [...customFormObject];
      customFormObj.splice(pIndex, 1, selectTypeDat);
      setcustomFormBuilder(customFormObj);
    }
    if (selectTypeDatOptions.length > 1 && selectTypeDatOptions.length - 1 !== index && orderType === "down") {
      reset({});
      selectTypeDatOptions.splice(index, 0, selectTypeDatOptions[index + 1]);
      selectTypeDatOptions.splice(index + 2, 1);
      let orderChange = selectTypeDatOptions.map((value, index) => {
        let order = { ...value };
        order.order = (index + 1) * 1;
        return order;
      });
      selectTypeDat.options = orderChange;
      let customFormObj = [...customFormObject];
      customFormObj.splice(pIndex, 1, selectTypeDat);
      setcustomFormBuilder(customFormObj);
    }
  };

  const addRuleData = (ruleValue, pIndex, index) => {
    handleAddMediaCancel();
    let customFormObject = [...customFormBuilder];
    const rule = customFormObject.slice(0, pIndex + 1);
    setRuleList(rule);
    setmodalShowRule(true);
    setIndex({ pIndex: pIndex, index: index });
    setEditRule(ruleValue);
    setRuleEmpty("");
    reset({});
  };

  const productFamilyCode = (code, index, pIndex, filter) => {
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[pIndex] };
    let opt = [...selectTypeDat.options];
    let optInd = { ...opt[index] };
    optInd.productFamily = code;
    optInd.productFilter = filter;
    opt.splice(index, 1, optInd);
    selectTypeDat.options = opt;
    let customFormObj = [...customFormObject];
    customFormObj.splice(pIndex, 1, selectTypeDat);
    setcustomFormBuilder(customFormObj);
  };
  const productMaterialCode = (code, index, pIndex, filter) => {
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[pIndex] };
    let opt = [...selectTypeDat.options];
    let optInd = { ...opt[index] };
    optInd.productMaterial = code;
    optInd.productFamily = "";
    optInd.productFilter = "";
    opt.splice(index, 1, optInd);
    selectTypeDat.options = opt;
    let customFormObj = [...customFormObject];
    customFormObj.splice(pIndex, 1, selectTypeDat);
    setcustomFormBuilder(customFormObj);
  };

  const getRuleData = (rule) => {
    const pIndex = getIndex?.pIndex;
    const index = getIndex?.index;
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[pIndex] };
    if (index !== undefined) {
      let opt = [...selectTypeDat.options];
      let optInd = { ...opt[index] };
      optInd.rule = rule;
      opt.splice(index, 1, optInd);
      selectTypeDat.options = opt;
      selectTypeDat.rule = null;
    } else {
      selectTypeDat.rule = rule;
      let removeRule = [...selectTypeDat.options].map((value, ind) => {
        let ruleOption = { ...selectTypeDat.options[ind] };
        ruleOption.rule = null;
        return ruleOption;
      });
      selectTypeDat.options = removeRule;
    }
    let customFormObj = [...customFormBuilder];
    customFormObj.splice(pIndex, 1, selectTypeDat);
    setcustomFormBuilder(customFormObj);
    if (getRuleIndex.includes(selectTypeDat?.id)) {
      let getRule = [...getRuleIndex];
      getRule.pop(selectTypeDat?.id);
      setGetRuleIndex(getRule);
    }
  };

  const isQuestionValid = (question) => {
    if (!question?.desc?.trim()) return false;
    if (question.type === "text") return true;
    return question.options?.some((opt) => opt.value?.trim());
  };

  const getLastQuestionToValidate = (sectionIndex) => {
    if (sectionIndex !== null) {
      const section = sectionInfo[sectionIndex];
      if (!section?.questionsId?.length) return null;

      const lastTempId = section.questionsId[section.questionsId.length - 1];

      return customFormBuilder.find((q) => q.tempId === lastTempId);
    }

    const unsectioned = customFormBuilder.filter((q) => !sectionedQuestionIds.has(q.tempId));

    return unsectioned[unsectioned.length - 1] || null;
  };

  const getLastQuestionForAddSection = () => {
    if (sectionInfo.length > 0) {
      const lastSection = sectionInfo[sectionInfo.length - 1];

      if (lastSection.questionsId.length > 0) {
        const lastTempId = lastSection.questionsId[lastSection.questionsId.length - 1];

        return customFormBuilder.find((q) => q.tempId === lastTempId) || null;
      }
    }

    const unsectioned = customFormBuilder.filter((q) => !sectionedQuestionIds.has(q.tempId));

    return unsectioned[unsectioned.length - 1] || null;
  };

  const nextQuestion = (sectionIndex = null) => {
    handleAddMediaCancel();
    const lastQuestion = getLastQuestionToValidate(sectionIndex);
    if (lastQuestion && !isQuestionValid(lastQuestion)) {
      setQuestionError({ index: getQuestionIndex(lastQuestion.tempId) });
      return;
    }
    setQuestionError({});

    setcustomFormBuilder((prev) => {
      const unsectioned = prev.filter((q) => !sectionedQuestionIds.has(q.tempId));

      const newQuestion = {
        id: 0,
        tempId: crypto.randomUUID(),
        desc: "",
        coreDesc: "",
        order: sectionIndex === null ? unsectioned.length + 1 : sectionInfo?.[sectionIndex]?.questionsId?.length + 1,
        options: [],
        optionType: null,
        media: {
          images: [],
          embedVideo: [],
        },
        isMandatory: 0,
      };

      if (sectionIndex !== null) {
        setSectionInfo((prevSections) =>
          prevSections.map((sec, idx) =>
            idx === sectionIndex
              ? {
                  ...sec,
                  questionsId: [...sec.questionsId, newQuestion.tempId],
                }
              : sec
          )
        );
      }

      return [...prev, newQuestion];
    });
  };

  const handleCancelBtn = () => {
    setCloseWarning(true);
    window.scrollTo(0, 0);
  };

  const getOptionValue = (value, index, pIndex) => {
    handleAddMediaCancel();

    setcustomFormBuilder((prev) => {
      if (pIndex < 0 || pIndex >= prev.length) return prev;

      const updated = [...prev];
      const question = updated[pIndex];
      const options = Array.isArray(question.options) ? [...question.options] : [];

      if (index < 0 || index >= options.length) return prev;

      options[index] = {
        ...options[index],
        key: String(index + 1),
        value: value || "",
      };

      updated[pIndex] = {
        ...question,
        options,
      };

      return updated;
    });
  };

  const getGotoValue = (value, pIndex, index = "") => {
    handleAddMediaCancel();
    let customFormObject = [...customFormBuilder];
    let selectTypeDat = { ...customFormObject[pIndex] };
    if (index === "") {
      selectTypeDat.goto = value;
      delete selectTypeDat.rule;
    } else {
      selectTypeDat.goto = "";
      let optionsVal = { ...selectTypeDat.options[index] };
      optionsVal.goto = value !== "" ? value : "";
      delete optionsVal.rule;
      let addOptionsValue = [...selectTypeDat.options];
      addOptionsValue.splice(index, 1, optionsVal);
      selectTypeDat.options = addOptionsValue;
    }
    let customFormObj = [...customFormObject];
    customFormObj.splice(pIndex, 1, selectTypeDat);
    setcustomFormBuilder(customFormObj);
  };

  const getQutions = (value, index) => {
    const updateFormBuilder = [...customFormBuilder];
    updateFormBuilder[index] = { ...updateFormBuilder[index], desc: value || "" };
    setcustomFormBuilder(updateFormBuilder);
  };

  const getQutionsCoreDesc = (value, index) => {
    const updateFormBuilder = [...customFormBuilder];
    updateFormBuilder[index] = { ...updateFormBuilder[index], coreDesc: value || "" };
    setcustomFormBuilder(updateFormBuilder);
  };

  const deleteQuestion = (value, index) => {
    handleAddMediaCancel();
    setDeleteIndRule(false);
    setDeleteInd(index);
    setDeleteQuestionCon(true);
    if (value && value.rule && value.rule !== null) {
      setDeleteIndRule(true);
    }
    if (value && value.options) {
      let chck_rule = 0;
      Array.isArray(value.options) &&
        value.options.map((valueOpt) => {
          if (valueOpt && valueOpt.rule && valueOpt.rule !== null) {
            chck_rule = 1;
          }
        });
      if (chck_rule === 1) {
        setDeleteIndRule(true);
      }
    }
    if (customFormBuilder && Array.isArray(customFormBuilder) && customFormBuilder.length > 0) {
      let chck_rule_all = 0;
      customFormBuilder.map((all_value, inds) => {
        Array.isArray(all_value.options) &&
          all_value.options.map((valueOpt) => {
            if (value.optionType === "productattribute" && valueOpt && valueOpt.rule) {
              Array.isArray(valueOpt?.rule?.attribute) &&
                valueOpt?.rule?.attribute.map((value_attr) => {
                  if (value_attr === value.id) {
                    chck_rule_all = 1;
                  }
                });
            }
            if (value.optionType === "productfamily" && valueOpt && valueOpt.rule) {
              Array.isArray(valueOpt?.rule?.productQuestion) &&
                valueOpt?.rule?.productQuestion.map((value_family) => {
                  if (value_family === value.id) {
                    chck_rule_all = 1;
                  }
                });
            }
          });
      });
      if (chck_rule_all === 1) {
        setDeleteIndRule(true);
      }
    }
  };

  const deleteList = () => {
    handleAddMediaCancel();
    setDeleteQuestionCon(false);

    const currentList = [...customFormBuilder];
    const deletedQuestion = currentList[deleteInd];

    if (!deletedQuestion) return;
    const { tempId, id } = deletedQuestion;

    let quesId = [];
    currentList.forEach((item, pIndex) => {
      if (deleteInd < pIndex) {
        if (item?.rule?.attribute?.includes(id) || item?.rule?.productQuestion?.includes(id)) {
          quesId.push(item.id);
        }

        item?.options?.forEach((opt) => {
          if (opt?.rule?.attribute?.includes(id) || opt?.rule?.productQuestion?.includes(id)) {
            quesId.push(item.id);
          }
        });
      }
    });

    setGetRuleIndex(quesId);

    const updatedQuestions = currentList.filter((_, idx) => idx !== deleteInd);

    setcustomFormBuilder(updatedQuestions);

    setSectionInfo((prevSections) =>
      prevSections
        .map((section) => ({
          ...section,
          questionsId: section.questionsId.filter((qid) => qid !== tempId),
        }))
        .filter((section) => section.questionsId.length > 0)
    );

    reset({});
  };

  const modalClose = () => {
    setmodalShow(false);
    setmodalShowRule(false);
    setDeleteQuestionCon(false);
  };

  let nextQuestionOption = customFormBuilder?.length - 1;
  let questionType = customFormBuilder[nextQuestionOption]?.type;

  const handleYes = () => {
    setCloseWarning(false);
    history.push("/admin/formBuilder");
  };
  /* No fn */
  const handleNo = () => {
    handleAddMediaCancel();
    setCloseWarning(false);
  };
  const handleAddMedia = (index) => {
    setAddMedia({ index: index });
  };
  const handleAddMediaCancel = () => {
    setAddMedia({});
  };

  const handleAddSection = () => {
    const lastQuestion = getLastQuestionForAddSection();
    if (lastQuestion && !isQuestionValid(lastQuestion)) {
      const errorIndex = getQuestionIndex(lastQuestion.tempId);
      setQuestionError({ index: errorIndex });
      return;
    }

    setQuestionError({});
    setSectionInfo((prev, i) => [
      ...prev,
      {
        name: `Section ${prev.length + 1}`,
        sectionPlaceholder: "",
        isMandatory: 0,
        questionsId: [],
      },
    ]);
  };

  const questionMap = useMemo(() => {
    const map = {};
    customFormBuilder.forEach((q) => {
      map[q?.tempId] = q;
    });
    return map;
  }, [customFormBuilder]);

  const sections = useMemo(() => {
    return sectionInfo.map((section) => ({
      name: section.name,
      sectionPlaceholder: section.sectionPlaceholder,
      isMandatory: section.isMandatory,
      questions: section.questionsId.map((id) => questionMap[id]).filter(Boolean),
    }));
  }, [sectionInfo, questionMap]);

  const handleSectionTitle = (value, sectionIndex) => {
    setSectionInfo((prevSections) =>
      prevSections.map((section, idx) =>
        idx === sectionIndex
          ? {
              ...section,
              sectionPlaceholder: value,
            }
          : section
      )
    );
  };

  const getQuestionIdsBySection = (sectionIndex) => {
    if (sectionIndex === null) {
      return unSectionedQuestions.map((q) => q.tempId);
    }
    return sectionInfo[sectionIndex].questionsId;
  };

  const setQuestionIdsBySection = (sectionIndex, newIds) => {
    if (sectionIndex === null) {
      return;
    }

    setSectionInfo((prev) => prev.map((sec, idx) => (idx === sectionIndex ? { ...sec, questionsId: newIds } : sec)));
  };

  const moveQuestionBetweenSections = (fromSectionIndex, fromIndex, toSectionIndex, toIndex, tempId) => {
    if (fromSectionIndex === toSectionIndex) return;
    const sourceIds = [...getQuestionIdsBySection(fromSectionIndex)];
    sourceIds.splice(fromIndex, 1);

    if (fromSectionIndex !== null) {
      setQuestionIdsBySection(fromSectionIndex, sourceIds);
    }

    if (toSectionIndex !== null) {
      const targetIds = [...getQuestionIdsBySection(toSectionIndex)];
      targetIds.splice(toIndex, 0, tempId);
      setQuestionIdsBySection(toSectionIndex, targetIds);
    }
  };

  const onDragStart = (fromSectionIndex, fromIndex, tempId) => {
    dragItemRef.current = {
      fromSectionIndex,
      fromIndex,
      tempId,
    };
  };

  const onDragOver = (e, sectionIndex, overIndex) => {
    e.preventDefault();
    handleAutoScroll(e);

    setDragOverTarget({
      sectionIndex,
      questionIndex: overIndex,
    });
  };

  const onDrop = (toSectionIndex, toIndex) => {
    const dragItem = dragItemRef.current;
    if (!dragItem) return;

    const { fromSectionIndex, fromIndex, tempId } = dragItem;

    if (fromSectionIndex === toSectionIndex && fromIndex === toIndex) {
      return;
    }

    moveQuestionBetweenSections(fromSectionIndex, fromIndex, toSectionIndex, toIndex, tempId);
    dragItemRef.current = null;
    setDragOverTarget({ sectionIndex: null, questionIndex: null });
  };

  const renderQuestion = (value, isLastInGroup, groupIndex, sectionIndex = null, isMandatory = false) => {
    const index = customFormBuilder.findIndex((item) => item.tempId === value?.tempId);
    return (
      <div
        className={styles.question_blk}
        key={value.tempId}
        draggable
        onDragStart={() => onDragStart(sectionIndex, groupIndex, value.tempId)}
        onDragOver={(e) => onDragOver(e, sectionIndex, groupIndex)}
        onDrop={() => onDrop(sectionIndex, groupIndex)}
      >
        {dragOverTarget.sectionIndex === sectionIndex && dragOverTarget.questionIndex === groupIndex && (
          <div className={styles.drop_placeholder}>Drop here...</div>
        )}

        <div className={`col-sm-12 ${styles.col_spec} ${styles.question_top} align-items-center`}>
          <p className={`${styles.question_heading}`}>Question {groupIndex + 1}</p>

          <div className={`verticalCode ${styles.vertical_Code}`}></div>

          <Toggle
            checked={value?.isMandatory === 1}
            type="question"
            index={index}
            onChange={handleToggle}
            customStyle="pt-2"
            disabled={isMandatory}
          />

          <div className={`col-10 w-100 ${styles.media_view}`}>
            <ul className={`${styles.list_view} ml-5`}>
              {value?.media?.images?.map((valueImg, indexImg) => (
                <li key={indexImg}>
                  <img src={ImageIcon} alt="image_icon" />
                  <a href={valueImg?.image} target="_blank" rel="noopener noreferrer" title={valueImg?.fileName}>
                    {valueImg?.fileName}
                  </a>
                  <span onClick={() => handleDeleteImage(value?.media?.images, formData?.id, value?.id, index, indexImg)} title="Remove">
                    <img src={CloseIcon} alt="close" />
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <p className={styles.up_down_list}>
            {groupIndex !== 0 && (
              <span className={`${styles.sequence_arrow} uparrow`} onClick={() => upArrowSequence(value?.tempId, sectionIndex)}>
                <img src={topArrow} alt="Top arrow" />
              </span>
            )}
            {!isLastInGroup && (
              <span className={`${styles.sequence_arrow} downarrow`} onClick={() => downArrowSequence(value?.tempId, sectionIndex)}>
                <img src={downArrow} alt="Down arrow" />
              </span>
            )}
            <span className={`${styles.sequence_arrow} deleteQues`} onClick={() => deleteQuestion(value, index)}>
              <img src={deleteIcon} alt="delete" />
            </span>
            <Tooltip placement="left" className="mt-2" content={constants.customForm.questionDragDrop}>
              <i className="fas" style={{ fontSize: "20px", color: "#787878" }}>
                &#xf58e;
              </i>
            </Tooltip>
          </p>
        </div>

        <div className={`${styles.form_block1} mb-2`}>
          <QuestionBody
            qvalue={value}
            pIndex={index}
            customFormBuilder={customFormBuilder}
            formData={formData}
            branch={branch}
            addBranchIndex={addBranchIndex}
            getRuleIndex={getRuleIndex}
            dropRef={dropRef}
            register={register}
            errors={errors}
            showQuestionError={showQuestionError}
            getQutions={getQutions}
            getQutionsCoreDesc={getQutionsCoreDesc}
            selectAnswerType={selectAnswerType}
            getAttributeVal={getAttributeVal}
            fetchValue={fetchValue}
            getGotoValue={getGotoValue}
            getInputValue={getInputValue}
            addRuleData={addRuleData}
            addBranch={addBranch}
            addBranchValue={addBranchValue}
            addNewQuestionOption={addNewQuestionOption}
            addMedia={addMedia}
            handleAddMedia={handleAddMedia}
            handleAddMediaCancel={handleAddMediaCancel}
            setcustomFormBuilder={setcustomFormBuilder}
            setSectionInfo={setSectionInfo}
            getOptionValue={getOptionValue}
            deleteAnswerOption={deleteAnswerOption}
            productFamilyCode={productFamilyCode}
            productMaterialCode={productMaterialCode}
            productAttributeOrderChange={productAttributeOrderChange}
          />
        </div>

        {isLastInGroup && (
          <div className={styles.question_add_new} title="Add Next Question">
            <button type="button" className="btn btn-transparent next-ques" onClick={() => nextQuestion(sectionIndex)}>
              <img src={plusIconWhite} alt="Plus icon" />
            </button>
          </div>
        )}
      </div>
    );
  };

  if (isFormLoading) {
    return (
      <div className={`loader col-12`}>
        <img src={Loader} alt="loading" />
      </div>
    );
  }

  return (
    <>
      {closeWarning && (
        <div className="text-center">
          <CloseWarning message="All progress in this section will be lost. Are you sure want to cancel?" yesFn={handleYes} noFn={handleNo} />
        </div>
      )}
      {deleteQuestionCon && (
        <Confirmation onClose={() => modalClose()} title={" "}>
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warnning-icon" />
            </p>
            <p className="pb-3">Are you sure you'd like to delete Question.{deleteIndRule && <>This question affect the rule</>}</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${styles.yes_btn}` }} onClick={() => deleteList()} />
              <Button id="closeId" value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${styles.no_btn}` }} onClick={() => modalClose()} />
            </div>
          </div>
        </Confirmation>
      )}
      <>
        <FormHeader
          onAddSection={handleAddSection}
          onAddQuestion={nextQuestion}
          unSectionedQuestions={unSectionedQuestions}
        />
        <div className={`col-md-12 ${styles.single_product_block} formbuilder`}>
          {upDateStatus && upDateStatus.status === "success" && (
            <div className={`alert alert-success ${styles.form_alert} ${styles.sucessmsg}`}>Successfully updated</div>
          )}
          {upDateStatus && upDateStatus.status === "error" && <div className={`alert alert-danger ${styles.form_alert}`}>Form not update</div>}
          {ruleEmpty !== "" && <div className={`alert alert-danger ${styles.form_alert} ${styles.sucessmsg}`}>{ruleEmpty}</div>}
          <div className="row">
            <div className={`p-0 ${styles.patient_content}`}>
              <Form formChanges={true} className={`pl-2 pt-0 ${styles.patient_content} formSubmit`} onSubmit={handleSubmit(onSubmit)}>
                {sections.map((section, sectionIndex) => (
                  <SectionBlock
                    key={sectionIndex}
                    section={section}
                    sectionIndex={sectionIndex}
                    renderQuestion={renderQuestion}
                    handleSectionTitle={handleSectionTitle}
                    handleSectionToggle={handleSectionToggle}
                    sectionRefs={sectionRefs}
                    errors={errors}
                    onDragOver={onDragOver}
                    onDrop={onDrop}
                    onDragStart={onDragStart}
                    dragOverTarget={dragOverTarget}
                    onAddQuestion={nextQuestion}
                    dragItemRef={dragItemRef}
                  />
                ))}

                <UnSectionBlock
                  unSectionedQuestions={unSectionedQuestions}
                  unSectionRefs={unSectionRefs}
                  renderQuestion={renderQuestion}
                  dragOverTarget={dragOverTarget}
                  dragItemRef={dragItemRef}
                  onDragStart={onDragStart}
                  onDragOver={onDragOver}
                  onDrop={onDrop}
                  sections={sections}
                />

                {sections?.length === 0 && unSectionedQuestions?.length === 0 && (
                  <div className={`col-12 ${styles.noSelection}`}>Start by adding a question or a section</div>
                )}

                {getRule && <AddRule modalOpen={modalShow} modalClose={modalClose} addRuleButton={addRuleButton} />}
                {
                  <AddRuleText
                    modalOpen={modalShowRule}
                    modalClose={modalClose}
                    addRuleList={ruleList}
                    getRuleData={getRuleData}
                    defaultValue={editRule}
                  />
                }
                {questionType !== undefined && <FormFooter show={questionType} onCancel={handleCancelBtn} />}
              </Form>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
